<template>
  <div class="text-field">
    <div class="text-field__input">
        <input id="voucher_code" type="text" class="form-control text-field__control" :placeholder="placeholder" :value="value" @input="inputHandler">
    </div>
      <label v-if="status === 'error'" class="form-label voucher_error"><i class="fa fa-times-circle-o"></i> {{errorText}}</label>
      <label v-if="status === 'ok'" class="form-label voucher_ok" ><i class="fa fa-check"></i> {{ okText }}</label>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    errorText:{
      type: String,
      default: ''
    },
    okText:{
      type: String,
      default: ''
    },
    status:{
      type: String,
      default: 'none'
    }
  },
  methods: {
    inputHandler(ev) {
      this.$emit('input', ev.target.value);
    }

  }
}
</script>

<style>
.voucher_error{
    color:red;
}
.voucher_ok{
    color:green;
}

</style>
